<template>
    <div v-if="emails">
        <template v-for="(email, index) in emails">
            <a :key="email" :href="'mailto:' + email">{{ email }}</a>
            <span :key="email" v-if="index + 1 < emails.length">,&nbsp;</span>
        </template>
    </div>
</template>

<script>
export default {
    props: {
        emails: {
            type: Array,
            default: null,
            required: true,
        },
    },
};
</script>
